module.exports = __webpack_public_path__ + "assets/img/lz4.90da040a.png";